import axios from "axios";

const resolveApiBaseUrl = () => {
  const useLocalServerInDev = process.env.NODE_ENV === "development" && process.env.REACT_APP_USE_LOCAL_SERVER === "true"

  if (useLocalServerInDev) {
    return process.env.REACT_APP_LOCAL_API_BASE_URL || "http://localhost:23115"
  }

  return process.env.REACT_APP_API_BASE_URL || ""
}

// Set axios base URL from environment (dev/prod)
const baseURL = resolveApiBaseUrl()
if (baseURL) {
  axios.defaults.baseURL = baseURL
}

export const getApiBaseUrl = () => baseURL

export const setupAxiosInterceptors = () => {
  axios.interceptors.request.use(
    (config) => {
      const userInfo = localStorage.getItem("userInfo");
      if (userInfo) {
        const { token } = JSON.parse(userInfo);
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        // Token expired or invalid
        localStorage.removeItem("userInfo");
        localStorage.removeItem("cartItems");
        window.location.href = "/login";
      }
      return Promise.reject(error);
    }
  );
};
